import { render, staticRenderFns } from "./smallInfo.vue?vue&type=template&id=2a834c9f&"
import script from "./smallInfo.vue?vue&type=script&lang=js&"
export * from "./smallInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports